import request from '@/utils/request';

// AI 接口超时时间单独设为 120 秒（大模型响应较慢）
const AI_TIMEOUT = 120000;

/** 步骤3：推荐模板 */
export function generateTemplate(data) {
    return request({ url: '/front/ai/template', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤5：生成故事背景 */
export function generateBackground(data) {
    return request({ url: '/front/ai/background', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤6：生成角色列表 */
export function generateRoles(data) {
    return request({ url: '/front/ai/roles', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤7：生成故事情节 */
export function generatePlot(data) {
    return request({ url: '/front/ai/plot', method: 'post', data, timeout: AI_TIMEOUT });
}

/** 步骤8辅助：生成标题建议 */
export function generateTitles(data) {
    return request({ url: '/front/ai/titles', method: 'post', data, timeout: AI_TIMEOUT });
}
